import cookie from "react-cookies";
import { isIE } from "react-device-detect";
/**
 * 쿠키및 브라우져 셋팅 언어셋 리스트
 */
export const detectLanguages = () => {
	var langs = [cookie.load("_lang"), navigator.languages && navigator.languages[0]];
	if (navigator.languages) {
		langs = langs.concat(navigator.languages.slice(1));
	}
	langs = langs.filter((val) => val); //없는 값 제거하는 필터링

	return langs;
};
/**
 * 지원가능한 언어셋
 */
export const allowLanguage = () => {
	const possibleLanguages = ["ko", "en", "ja", "th", "zh", "zh-TW", "vi"];
	let langs = detectLanguages();

	for (let i = 0; i < langs.length; i++) {
		var lang = langs[i];
		lang = lang.replace("_", "-");

		//중국어예외처러
		if (["zh-hk", "zh-mo", "zh-hant"].indexOf(lang.toLowerCase()) > -1) {
			lang = "zh-TW";
		}

		if (possibleLanguages.indexOf(lang) >= 0) return lang;

		if (lang.indexOf("-") >= 0) {
			lang = lang.split("-")[0];
			if (possibleLanguages.indexOf(lang) >= 0) return lang;
		}
	}
	return "ko"; //기본값
};

export const getFileExtension = (file: string) => {
	const regexp = new RegExp(".([0-9a-z]+)(?:[?#]|$)", "i");
	const extension = file.match(regexp);
	return extension && extension[1];
};
//error 발생하면 같은 메시지로는 업데이트 되지 않음
export const numberCommaString = (value: string | number) => {
	if (!value) {
		return 0;
	}
	if (isIE) {
		return Number(value).toLocaleString().replace(".00", "");
	} else {
		return Number(value).toLocaleString();
	}
};
